import * as React from 'react'
import { Box, Typography, Badge } from '@mui/material';
import { TooltipSeeker } from "@ui-seeker/core";
import { formatPriceSymbol } from "@ui-seeker/utils";

export default function priceColumn(name, label, showStock=false) {
	return {
		name: name, label: label,
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { currency, myStockCount }) => {
				return <Box sx={{ display: 'flex', alignItems: 'center'}}>
					<Typography>{formatPriceSymbol(value, currency)}</Typography>
					{showStock && <TooltipSeeker title={myStockCount ? 'In Stock' : 'Out of Stock'} >
						<Badge 
							color={myStockCount ? 'success' : 'error'} 
							badgeContent=""
							sx={{ ml: 2 }} 
						/>
					</TooltipSeeker>}
				</Box> 
			}
		}
	}
}